import React from 'react';
import { machineStatusColorName, machineStatusName } from './functions';
import I18n from 'i18n-js';
import { Text, View } from 'react-native';

const StatusBuble = ({ status, canBeSmall, nameSum, scale, C, font }) => {
  const name = I18n.t(machineStatusName[status]);

  const isSmall = (nameSum > 17 && canBeSmall) || !status;

  const statusColor = machineStatusColorName?.[status] ?? 'Wallboard/Light/Not Productive';

  return (
    <View
      style={[
        {
          backgroundColor: C(statusColor),
          justifyContent: 'center',
        },
        isSmall
          ? {
              width: scale(22),
              height: scale(22),
              borderRadius: scale(22) / 2,
            }
          : {
              minWidth: scale(48),
              maxWidth: scale(145),
              paddingHorizontal: scale(16),
              height: scale(21),
              borderRadius: scale(11),
            },
      ]}
    >
      {!isSmall && (
        <Text style={[font['Button 3'], { color: C('Label/Light/AlwaysLight Primary'), textAlign: 'center' }]} numberOfLines={1} ellipsizeMode="tail">
          {name}
        </Text>
      )}
    </View>
  );
};

const MachineStatus = ({ font, scale, oldMachineStatus, machineStatus, C, Svg }) => {
  const nameSum = (I18n.t(machineStatus.status) + I18n.t(oldMachineStatus?.status))?.length;

  return (
    <View style={{ width: '100%' }}>
      <View
        style={{ width: '100%', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}
      >
        <StatusBuble {...{ status: oldMachineStatus?.status, canBeSmall: true, C, font, nameSum, scale }} />
        <View style={{ paddingHorizontal: scale(5) }}>
          <Svg icon="bigArrow" width={scale(32)} height={scale(13)} color="Label/Dark/Secondary" />
        </View>
        <StatusBuble {...{ status: machineStatus.status, C, font, nameSum, scale }} />
      </View>
    </View>
  );
};

export default MachineStatus;
